import axios from 'axios';
import _get from 'lodash/get';
import { ConfigurationMissingError, ConfigurationServiceError } from '../errors';
import getItem from '../utils/storage';

const fetchConfigData = (configKey, cacheBust) => {
  const configUrl = `${process.env.CONFIG_SERVICE_URL}/${configKey}${
    cacheBust ? `?date=${Date.now()}` : ''
  }`;

  if (getItem('error') === 'config') {
    return Promise.reject(new ConfigurationServiceError());
  }

  return axios
    .get(configUrl, {
      headers: { 'x-api-key': process.env.CONFIG_SERVICE_API_KEY }
    })
    .then(({ data }) => {
      return _get(data, 'data.config');
    })
    .catch(error => {
      const status = _get(error, 'response.status');
      switch (status) {
        case 500:
        case 502:
        case 503:
        case 504:
          throw new ConfigurationServiceError();
        default:
          throw new Error(`Error fetching configuration: ${error.message || 'Unknown'}`);
      }
    });
};

const parse = (key, config) => {
  if (!config) {
    throw new ConfigurationMissingError(`Unable to retrieve configuration (${key}).`);
  }
  const { usageKey, payload, auth, disabled } = config;
  return {
    disabled,
    usageKey,
    auth,
    payload: JSON.parse(payload)
  };
};

export default {
  getConfig: (config, cacheBust) => {
    return fetchConfigData(config, cacheBust).then(res => parse(config, res));
  }
};
